var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
const locationUrl = "/aviso/location";
export default class LocationService {
    static getLocations(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/locations/search/findByNameContainingIgnoreCase", {
                params: { search, sort: "name" },
            });
            return response.data._embedded.locations;
        });
    }
    static searchLocations(query, max = null, offset = null) {
        return FetchService.getSingleResponse(locationUrl + "/list", {
            query,
            max,
            offset,
            format: "json",
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse(locationUrl + "/search", {
            query: search === null || search === void 0 ? void 0 : search.query,
            createdDateFrom: search === null || search === void 0 ? void 0 : search.createdDateFrom,
            createdDateTo: search === null || search === void 0 ? void 0 : search.createdDateTo,
            modifiedDateFrom: search === null || search === void 0 ? void 0 : search.modifiedDateFrom,
            modifiedDateTo: search === null || search === void 0 ? void 0 : search.modifiedDateTo,
            locationStatusesInclude: search === null || search === void 0 ? void 0 : search.locationStatusesInclude,
            locationStatusesExclude: search === null || search === void 0 ? void 0 : search.locationStatusesExclude,
            ids: search.ids,
            max: options === null || options === void 0 ? void 0 : options.max,
            offset: options === null || options === void 0 ? void 0 : options.offset,
            sort: options === null || options === void 0 ? void 0 : options.sort,
            order: options === null || options === void 0 ? void 0 : options.order,
        });
    }
    static findLocationsById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/locations/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.locations;
        });
    }
}
